import React from 'react'
import { Paper, Typography, Button } from '@material-ui/core'
import {
    ResidentTermDirectoryDetail,
    DocumentType,
    AuditDocumentDetail,
} from '../../../../models/DocumentAudit/types'

interface Props {
    isLoadingDirectory: boolean
    directory: ResidentTermDirectoryDetail | null
    selectedDocumentId?: number | null
    selectedPage?: number | null
    selectedCoordinates?: string | null
}

export const DocumentViewer = ({
    isLoadingDirectory,
    directory,
    selectedDocumentId,
    selectedPage,
    selectedCoordinates,
}: Props) => {
    if (isLoadingDirectory) {
        return (
            <Paper elevation={1} style={{ flex: 1, padding: 16 }}>
                <Typography>Loading document...</Typography>
            </Paper>
        )
    }

    const selectedDocument = !selectedDocumentId
        ? directory?.documents.find((doc) => doc.document_type === 'PDF')
        : directory?.documents.find((doc) => doc.id === selectedDocumentId)

    const documentUrl = selectedDocument?.file

    if (!documentUrl) {
        return (
            <Paper elevation={1} style={{ flex: 1, padding: 16 }}>
                <Typography>No document available</Typography>
            </Paper>
        )
    }

    // Handle different document types
    switch (selectedDocument.document_type) {
        case 'PDF':
            return (
                <Paper
                    elevation={1}
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <iframe
                        key={`${selectedDocumentId}-${selectedPage}`}
                        src={`${documentUrl}${
                            selectedPage ? `#page=${selectedPage}` : ''
                        }`}
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                        }}
                        title="Document Viewer"
                    />
                </Paper>
            )

        case 'EXCEL':
            return (
                <Paper
                    elevation={1}
                    style={{
                        flex: 1,
                        overflowY: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <iframe
                        key={`Excel-${selectedDocumentId}`}
                        id="excel-viewer"
                        width="100%"
                        height="100%"
                        loading="lazy"
                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                            selectedDocument.file,
                        )}&activeCell=${selectedCoordinates}`}
                    />
                </Paper>
            )

        default:
            return (
                <Paper elevation={1} style={{ flex: 1, padding: 16 }}>
                    <Typography>
                        Unsupported document type:{' '}
                        {selectedDocument.document_type}
                    </Typography>
                </Paper>
            )
    }
}
